@if (model.viewName === 'people') {
  <ng-scrollbar visibility="hover" [style.height]="'100%'" class="scrollbar">
    <div class="people-empty-state empty-state">
      <div class="inner-wrapper">
        <div class="image-wrapper admin" *hasPermission="'admin'; else memberImage">
          <u-icon
            [model]="{
              type: 'img',
              value: {
                lightUrl: './assets/people/empty-people.svg',
              },
            }"
            [inSvg]="'./assets/people/empty-people.svg'"
            [styles]="{ height: '107px' }"
          ></u-icon>
        </div>
        <div class="title">People</div>
        <div class="additional-title">Want to access employee directory?</div>
        <ng-container *hasPermission="'admin'; else memberEmptyState">
          <div class="sub-title">
            <div class="step">1</div>
            Select your company's HRIS tool
          </div>
          <div class="apps-wrapper">
            @for (appItem of appsDisplayItems; track appItem) {
              <div class="app-item" (click)="navigateToAppPage(appItem)">
                <u-icon [model]="{ type: 'img', value: appItem.icon }" [styles]="{ height: '24px', height: '24px' }"></u-icon>
                <u-truncate-text [text]="appItem.name"> </u-truncate-text>
              </div>
            }
          </div>
          <div class="sub-title">
            <div class="step">2</div>
            Set your relevant HRIS to get all the relevant <br />information of your colleagues
          </div>
          <u-button
            class="go-to-admin-btn"
            [versionNumber]="2"
            [typeElement]="'primary'"
            [sizeElement]="'medium'"
            (onClick)="goToSettings()"
            [label]="'Go to Admin Center'"
          ></u-button>
        </ng-container>
        <ng-template #memberEmptyState>
          <div class="sub-title">Contact your admin to connect relevant HRIS tool</div>
        </ng-template>
        <ng-template #memberImage>
          <div class="image-wrapper">
            <u-icon
              [model]="{
                type: 'img',
                value: {
                  lightUrl: './assets/people/empty-people.svg',
                },
              }"
              [inSvg]="'./assets/people/empty-people.svg'"
              [styles]="{ height: '107px' }"
            ></u-icon>
          </div>
        </ng-template>
      </div></div
  ></ng-scrollbar>
} @else {
  <section class="connect-apps-container" [ngClass]="{ 'no-apps': appsDisplayItems?.length === 0, 'add-padding': addPaddingTop }">
    <div class="scroll-area-container">
      <div *ngIf="model?.appsHeader" class="scroll-area-header">
        <h1
          class="step"
          [attr.step]="model.appsHeader.step"
          [innerHtml]="model.appsHeader.title | lineDownAt: model.appsHeader?.lineBreakAt"
        ></h1>
      </div>
      <cdk-virtual-scroll-viewport
        class="scroll-area"
        [class.scroll-area-with-header]="!!model.appsHeader"
        [itemSize]="48"
        scrollViewport
        *ngIf="appsDisplayItems?.length > 0"
      >
        <section>
          <app-list class="apps" [items]="appsDisplayItems" [mode]="'side'" [telemetryLocation]="telemetryLocation"> </app-list>
        </section>
      </cdk-virtual-scroll-viewport>
    </div>

    <section [ngClass]="{ 'right-side-widths': appsDisplayItems?.length > 0 }" class="right-side">
      <u-icon [model]="imgIcon" class="icon"></u-icon>
      <div class="text-container">
        <h1 data-cy="empty-state-right-side-text" class="text" [class.step]="!!model.title?.step" [attr.step]="model.title?.step">
          {{ allAppsDisable && !this.isOwnerOrAdmin ? model.disableAppsTitle : model.title.app }}
        </h1>
      </div>
    </section>
  </section>
}
